import React from 'react';
import { TextRoll } from './TextRoll';
type Variant = 'default' | 'muted' | 'footer' | 'email';
interface LinkButtonProps {
  label: string;
  href: string;
  variant?: Variant;
  external?: boolean;
}
const variantClass: Record<Variant, string> = {
  // All section CTAs (Get in touch, View Services, View more, Read more, Ask us a question)
  // are mid-grey and turn black on hover, like the live site.
  default: 'text-[1.25rem] font-medium tracking-[0.0125em] text-mute transition-colors duration-200 ease-out hover:text-black sm:text-[1.4375rem]',
  muted: 'text-[1.25rem] font-medium tracking-[0.0125em] text-mute transition-colors duration-200 hover:text-black sm:text-[1.4375rem]',
  footer: 'text-[1.25rem] font-normal tracking-[0.0125em] text-black sm:text-[1.4375rem]',
  email: 'text-[1.563rem] font-normal tracking-[0.025em] text-black'
};
export function LinkButton({
  label,
  href,
  variant = 'default',
  external
}: LinkButtonProps) {
  return <a href={href} target={external ? '_blank' : undefined} rel={external ? 'noreferrer' : undefined} className={`roll-link im-underline relative inline-block leading-none ${variantClass[variant]}`} data-id="element-1" data-mp="3o0ts5rj47iw8">
      <TextRoll label={label} data-id="element-2" data-mp="3hz5slouha3rw" />
    </a>;
}